/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, June 4th 2022, 5:08:37 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Stack from "@mui/material/Stack";
import GroupsIcon from "@mui/icons-material/Groups";
import { TeamSelectorInput } from "teams/components/TeamSelectorInputs";
import { Team } from "lib/schemas";
import { StyledOSDialog, OSLoadingButton, OSActionButton, OSActionButtonProps, useToggleState } from "ui-widgets";
import { useServiceBuilderContext } from "service-builder/providers";

interface ProcessDefinitionLinkTeamButtonProps extends Pick<OSActionButtonProps, "size"> {
  title?: string;
}

export const ProcessDefinitionLinkTeamButton = ({ title, size }: ProcessDefinitionLinkTeamButtonProps) => {
  const { handleClose, handleOpen, open } = useToggleState();
  return (
    <>
      <OSActionButton variant="contained" onClick={handleOpen} size="large">
        {title ?? <>Link a Team</>}
      </OSActionButton>
      <ProcessDefinitionLinkTeam open={open} handlePopupClose={handleClose} />
    </>
  );
};

interface ProcessDefinitionLinkTeamProps {
  open: boolean;
  handlePopupClose: () => void;
}

const ProcessDefinitionLinkTeam = ({ open, handlePopupClose }: ProcessDefinitionLinkTeamProps) => {
  const [team, setTeam] = React.useState<Team>();

  const [isSaving, setISaving] = React.useState<boolean>(false);

  const {
    processDefinitionContext: { currentProcessDefinition },
    patchCurrentProcessDefinition,
  } = useServiceBuilderContext();

  const linkTeam = (team: Team) => {
    if (!team) return;

    setISaving(true);
    patchCurrentProcessDefinition({ groups: [...currentProcessDefinition.groups, team.group] });
  };

  return (
    <StyledOSDialog
      popUpIcon={<GroupsIcon color="secondary" />}
      popUpTitle={`Link Team to ${currentProcessDefinition.title}`}
      open={open}
      onClose={handlePopupClose}
      className="os-task-team-access-modal"
    >
      <Stack spacing={2}>
        <TeamSelectorInput chosenTeam={team} setChosenTeam={setTeam} />
        <OSLoadingButton isLoading={isSaving} variant="contained" size="large" onClick={() => linkTeam(team)}>
          Link Team
        </OSLoadingButton>
      </Stack>
    </StyledOSDialog>
  );
};
